import { useMutation } from '@tanstack/react-query';
import service from '../service';

type CreateActivityPayload = Parameters<typeof service.createActivity>[0];

export function useCreateActivity() {
  return useMutation({
    mutationKey: ['activity', 'create'],
    mutationFn: (payload: CreateActivityPayload) => service.createActivity(payload),
  });
}
